( () => {

	const searchDialog = document.querySelector<HTMLDialogElement>( 'dialog[data-dialog-name="search-modal"]' );

	const searchInput = searchDialog?.querySelector<HTMLInputElement>( 'input[type="search"]' );

	document.addEventListener( 'openDialog', ( event: CustomEvent ) => {
		if ( event.detail.dialogName !== 'search-modal' ) return;
		searchInput?.focus();
	} );

	searchDialog.addEventListener( 'close', () => {
		document.dispatchEvent( new CustomEvent(
			'closeDialog',
			{
				detail: {
					dialogName: 'search-modal',
				},
			},
		) );
	} );

} )();
